import request from "@/api/request";
import unionAxios from "@/utils/union-axios";

//队伍成员列表
export const teamMemberList = (param) => {
  return request(
    `/web-h5/charge/rankingActivity/teamMemberList`,
    param,
    "POST",
  );
};

//踢出队员
export const proposer = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/proposer`, param);
};

//退出队伍
export const dropOutOfLine = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/dropOutOfLine`, param);
};
//解散队伍
export const dissolveTeam = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/dissolveTeam`, param);
};
